import { CSSProperties } from 'react';

import './ProgressBar.styl';

export type ProgressTone = 'primary' | 'success' | 'warn' | 'risk' | 'ink';

type Props = { value: number; tone?: ProgressTone; label: string; height?: 5 | 6 | 8; className?: string };

export function ProgressBar({ value, tone = 'primary', label, height = 6, className }: Props) {
  const clamped = Math.max(0, Math.min(100, Math.round(value)));
  const classes = ['a-progress', `a-progress--h${height}`];
  if (className) classes.push(className);
  return (
    <div
      className={classes.join(' ')}
      role="progressbar"
      aria-label={label}
      aria-valuemin={0}
      aria-valuemax={100}
      aria-valuenow={clamped}
    >
      <div className={`a-progress__fill a-progress__fill--${tone}`} style={{ width: `${clamped}%` } as CSSProperties} />
    </div>
  );
}
